(function(gsap) {
  const $announcementBar = document.querySelector('.js-announcement-bar');

  if (!$announcementBar) { return }

  // setup
  const $messages = $announcementBar.querySelectorAll('.message');
  let timelines = [];
  const speed = 50; // Fixed speed in pixels per second

  const helpers = function() {
    const sleep = function(ms) { return new Promise(res => setTimeout(res, ms)); };

    return { sleep };
  }();

  const createMarquee = ($element, groupIndex, elementIndex) => {
    const direction = 'right';
    const $trackBox = $element.querySelector('.message__track-box');
    const $originalChild = $element.querySelector('span');
    let distance = $originalChild.clientWidth;
    let duration = distance / speed;

    return gsap.timeline()
      .to($trackBox, {
        duration: duration,
        ease: 'none',
        x: direction === 'left' ? distance : distance * -1,
        onComplete() {
          timelines[groupIndex][elementIndex].play(0);
        },
        onReverseComplete() {
          timelines[groupIndex][elementIndex].reverse(0);
        },
      });
  };

  if ($messages.length > 1) {
    (function() {
      // setup marquee timelines w/gsap
      // each message has two tracks for seamless tracks-transition effect
      $messages.forEach(($message, groupIndex) => {
        const $messageTracks = $message.querySelectorAll('.message__track');

        if($messageTracks.length) {
          let tracks = [];

          $messageTracks.forEach(function($track, elementIndex) {
            tracks.push(createMarquee($track, groupIndex, elementIndex));
          });

          timelines.push(tracks);
        }
      });

      // setup row animation transition
      let currentMessage = 0;
      setInterval(async function() {
        const nextMessage = currentMessage + 1 < $messages.length ? currentMessage + 1 : 0;
        $messages[currentMessage].classList.add('transitioned');
        $messages[nextMessage].classList.remove('transitioned');
        await helpers.sleep(480);
        $messages[nextMessage].classList.remove('hidden');
        $messages[currentMessage].classList.add('hidden');

        currentMessage = nextMessage;
      }, 6000);
    }());
  }
})(window.gsap);
